import React from 'react';
import ChatBotComponent from './ChatBotComponent';
import { useSelector } from 'react-redux';
const ChatBotComponentContainer = props => {
    const { messages } = useSelector((state) => state.messages);
    const propsWithRedux = Object.assign(Object.assign({}, props), { messages });
    return React.createElement(ChatBotComponent, Object.assign({}, propsWithRedux));
};
export default ChatBotComponentContainer;
//# sourceMappingURL=ChatBotComponentContainer.js.map